import { Record } from "immutable";

export const hoverJobFromJSON = (json: Partial<IHoverJobData>): HoverJobRecord => {
  return new HoverJobRecord({ ...(json as any) });
};

export interface IHoverJobData {
  id: number;
  name: string;
  location_line_1: string;
  location_line_2: string;
  location_city: string;
  location_region: string;
  location_postal_code: string;
  location_country: string;
  state: string;
  approved: boolean;
  archived: boolean;
  property_type: string;
  updated_at: string;
  completed_at: string;
  created_at: string;
}

export interface IHoverJobRecord {
  id: number;
  name: string;
  location_line_1: string;
  location_line_2: string;
  location_city: string;
  location_region: string;
  location_postal_code: string;
  location_country: string;
  state: string;
  approved: boolean;
  archived: boolean;
  property_type: string;
  updated_at: string;
  completed_at: string;
  created_at: string;
}

export const defaultHoverJobProps: IHoverJobRecord = {
  id: 0,
  name: "",
  location_line_1: "",
  location_line_2: "",
  location_city: "",
  location_region: "",
  location_postal_code: "",
  location_country: "",
  state: "",
  approved: false,
  archived: false,
  property_type: "",
  updated_at: "",
  completed_at: "",
  created_at: "",
};

export class HoverJobRecord extends Record(defaultHoverJobProps) implements IHoverJobRecord {}
